(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-blog-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class YGBlogV1 extends HTMLElement {
      connectedCallback() {
        this.formatNumbers();
      }

      formatNumbers() {
        const locale = document.documentElement.lang || navigator.language || 'en-US';
        const formatter = new Intl.NumberFormat(locale);

        this.querySelectorAll('[data-yg-number]').forEach((node) => {
          const value = Number(node.getAttribute('data-yg-number'));

          if (!Number.isNaN(value)) {
            node.textContent = formatter.format(value);
          }
        });
      }
    }

    const boot = () => {
      if (!window.customElements.get('yg-blog-v1')) {
        window.customElements.define('yg-blog-v1', YGBlogV1);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-journey-timeline"] && !Shopify.designMode) return;
  try {
    
  // 定义 YGJourneyTimeline 自定义 Web Component 组件，用于实现心路历程/时光轴动画效果
  class YGJourneyTimeline extends HTMLElement {
    // 静态 Map，用于缓存第三方脚本（如 GSAP）的加载 Promise，防止同一页面中多个组件实例重复加载相同脚本
    static scriptPromises = new Map();

    constructor() {
      super();
      // 绑定 resize 和 shopify 主题编辑器事件处理函数的 this 上下文
      this.handleResize = this.handleResize.bind(this);
      this.handleSectionLoad = this.handleSectionLoad.bind(this);
    }

    // 组件挂载到 DOM 时触发的生命周期钩子
    connectedCallback() {
      // 获取需要固定（Pin）的容器目标
      this.pinTarget = this.querySelector('[data-pin-target]');
      // 获取时间轴中的所有文本节点（每一项）
      this.items = Array.from(this.querySelectorAll('[data-timeline-item]'));
      // 获取与之对应的所有媒体（图片）节点
      this.mediaItems = Array.from(this.querySelectorAll('[data-timeline-media]'));
      // 媒体查询：判断当前屏幕宽度是否大于等于 700px（桌面端）
      this.desktopMedia = window.matchMedia('(min-width: 700px)');
      // 当前激活项的索引，初始为 0
      this.activeIndex = 0;

      // 默认激活第一项
      this.setActive(0);
      // 监听窗口大小改变事件，采用被动模式优化滚动性能
      window.addEventListener('resize', this.handleResize, { passive: true });
      // 监听 Shopify 主题编辑器的区块重新加载事件，以保持在编辑器中的实时预览正常
      document.addEventListener('shopify:section:load', this.handleSectionLoad);
      // 执行初始化逻辑
      this.init();
    }

    // 组件从 DOM 中卸载时触发的生命周期钩子
    disconnectedCallback() {
      // 移除事件监听，防止内存泄漏
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('shopify:section:load', this.handleSectionLoad);

      // 如果有处于等待中的 requestAnimationFrame，取消它
      if (this.resizeFrame) {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = null;
      }

      // 销毁 GSAP 滚动固定场景
      this.destroyScene();
    }

    // 初始化时间轴组件
    async init() {
      // 如果没有固定目标、时间轴项为空，或者当前处于移动端（小于 700px），则无需初始化 GSAP，直接销毁可能存在的场景并激活第一项
      if (!this.pinTarget || this.items.length === 0 || !this.desktopMedia.matches) {
        this.destroyScene();
        this.setActive(0);
        return;
      }

      try {
        // 动态加载并等待 GSAP 核心库和 ScrollTrigger 插件加载完毕
        const { gsap, ScrollTrigger } = await this.loadLibraries();

        // 异步加载期间，如果组件已被卸载，或者窗口缩小便于 700px，则终止后续初始化
        if (!this.isConnected || !this.desktopMedia.matches) {
          return;
        }

        // 保存对库的引用，并创建滚动固定动画场景
        this.gsap = gsap;
        this.ScrollTrigger = ScrollTrigger;
        this.createScene();
      } catch (error) {
        console.error(error);
      }
    }

    // 动态加载依赖的 GSAP 和 ScrollTrigger 库
    async loadLibraries() {
      // 加载 GSAP 核心库
      await YGJourneyTimeline.loadScript('yg-vendor-gsap', this.dataset.gsapSrc, 'gsap');
      // 加载 ScrollTrigger 插件
      await YGJourneyTimeline.loadScript('yg-vendor-scrolltrigger', this.dataset.scrolltriggerSrc, 'ScrollTrigger');

      const { gsap, ScrollTrigger } = window;
      // 在 GSAP 中注册 ScrollTrigger 插件
      gsap.registerPlugin(ScrollTrigger);

      return { gsap, ScrollTrigger };
    }

    // 静态通用脚本加载器，支持多实例共享 Promise，避免重复插入 <script> 标签
    static loadScript(key, src, globalName) {
      // 如果全局变量已经存在，说明脚本已加载完成，直接返回
      if (window[globalName]) {
        return Promise.resolve(window[globalName]);
      }

      // 如果已经在加载中，返回现有的加载 Promise
      if (YGJourneyTimeline.scriptPromises.has(key)) {
        return YGJourneyTimeline.scriptPromises.get(key);
      }

      const promise = new Promise((resolve, reject) => {
        // 检查页面中是否已存在具有相同 data 属性的 script 标签
        const existing = document.querySelector(`script[data-yg-vendor="${key}"]`);

        if (existing) {
          existing.addEventListener('load', () => resolve(window[globalName]), { once: true });
          existing.addEventListener('error', () => reject(new Error(`Failed to load ${key}`)), { once: true });
          return;
        }

        // 创建新 script 标签并插入页面头部进行异步加载
        const script = document.createElement('script');
        script.src = src;
        script.async = false; // 保证按顺序执行
        script.dataset.ygVendor = key;
        script.onload = () => resolve(window[globalName]);
        script.onerror = () => reject(new Error(`Failed to load ${key}`));
        document.head.appendChild(script);
      });

      // 缓存该 Promise
      YGJourneyTimeline.scriptPromises.set(key, promise);
      return promise;
    }

    // 创建 GSAP 滚动固定（Pin）与进度监听场景
    createScene() {
      // 先清理已存在的场景，避免重复创建
      this.destroyScene();

      if (!this.ScrollTrigger || !this.desktopMedia.matches) {
        return;
      }

      // 使用 ScrollTrigger 创建滚动控制场景
      this.pinTrigger = this.ScrollTrigger.create({
        trigger: this,
        start: 'center center', // 当组件中心滚动到屏幕中心时开始固定
        end: () => {
          // 滚动段数：项数 - 1（至少 1 段）
          const scrollSegments = Math.max(this.items.length - 1, 1);
          // 单段滚动高度基准：取屏幕高度与容器高度的较大值
          const scrollBase = Math.max(window.innerHeight || 0, this.pinTarget.offsetHeight || 0);

          // 动态计算滚动固定结束的距离
          return `+=${scrollBase * scrollSegments * 0.7}`;
        },
        pin: this.pinTarget, // 固定目标元素
        pinSpacing: true, // 保留固定期间的占位空间，以使页面后方内容按部就班排列
        anticipatePin: 1, // 优化固定开始时的抖动
        invalidateOnRefresh: true, // 页面刷新/调整尺寸时，使缓动与测量值失效重新计算
        onUpdate: (self) => {
          // 监听滚动更新，根据当前的滚动进度同步切换激活索引
          this.syncActiveIndex(self.progress);
        },
        onRefresh: (self) => {
          // 页面刷新重置时，同步激活状态
          this.syncActiveIndex(self.progress);
        },
      });

      // 初始化激活状态为 0 进度
      this.syncActiveIndex(0);
    }

    // 销毁 GSAP ScrollTrigger 滚动固定场景
    destroyScene() {
      this.pinTrigger?.kill();
      this.pinTrigger = null;
    }

    // 根据滚动进度（0 到 1 之间的小数）计算并同步应当激活的项
    syncActiveIndex(progress) {
      const nextIndex = Math.min(this.items.length - 1, Math.floor(Math.max(progress, 0) * this.items.length));

      this.setActive(nextIndex);
    }

    // 设置指定索引的项为激活状态，并切换 CSS 类以显示相应的文字和图片
    setActive(index) {
      const safeIndex = Math.max(0, Math.min(index, this.items.length - 1));

      // 如果已经是当前激活项且已有激活状态，则无需重复操作
      if (safeIndex === this.activeIndex && this.hasActiveState) {
        return;
      }

      this.activeIndex = safeIndex;
      this.hasActiveState = true;

      // 遍历文本项，为激活项添加 active 类名，非激活项移除
      this.items.forEach((item, itemIndex) => {
        item.classList.toggle('yg-journey-timeline__item--active', itemIndex === safeIndex);
      });

      // 遍历媒体图片项，为激活项添加 active 类名以显示对应图片，非激活项移除以隐藏
      this.mediaItems.forEach((item, itemIndex) => {
        item.classList.toggle('yg-journey-timeline__media--active', itemIndex === safeIndex);
      });
    }

    // 窗口大小改变时的回调函数（带节流机制优化性能）
    handleResize() {
      if (this.resizeFrame) {
        cancelAnimationFrame(this.resizeFrame);
      }

      // 使用 requestAnimationFrame 避免频繁触发计算导致卡顿
      this.resizeFrame = requestAnimationFrame(() => {
        this.resizeFrame = null;

        if (this.desktopMedia.matches) {
          // 桌面端下：如果已创建滚动固定场景，刷新 ScrollTrigger；否则重新初始化
          if (this.pinTrigger) {
            this.ScrollTrigger?.refresh();
          } else {
            this.init();
          }
        } else {
          // 移动端下：销毁 GSAP 固定效果，回退到默认布局并激活第一项
          this.destroyScene();
          this.setActive(0);
        }
      });
    }

    // Shopify 主题编辑器后台加载/改动 Section 时的回调函数，确保可视化编辑状态能实时响应
    handleSectionLoad(event) {
      const timeline = event.target?.querySelector('yg-journey-timeline');

      // 仅当被加载的组件是当前组件实例时才触发
      if (timeline !== this) {
        return;
      }

      // 下一帧触发 resize，重新测算并初始化动画效果
      requestAnimationFrame(() => {
        this.handleResize();
      });
    }
  }

  // 避免自定义元素重复定义报错，检查后进行注册
  if (!window.customElements.get('yg-journey-timeline')) {
    window.customElements.define('yg-journey-timeline', YGJourneyTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-marquee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-text-with-swpier"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-yg-tws-track]').forEach((track) => {
    const section = track.closest('.yg-tws-scroll');
    if (!section) return;

    const dots = section.querySelectorAll('[data-yg-tws-dot]');
    if (!dots.length) return;

    const items = track.querySelectorAll('.yg-tws-item');
    const totalItems = items.length;
    const totalDots = dots.length;
    if (!totalItems || !totalDots) return;

    function updateDots() {
      const scrollLeft = track.scrollLeft;
      const scrollWidth = track.scrollWidth - track.clientWidth;
      if (scrollWidth <= 0) return;

      const progress = scrollLeft / scrollWidth;
      const activeIndex = Math.min(Math.round(progress * (totalDots - 1)), totalDots - 1);

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === activeIndex);
      });
    }

    track.addEventListener('scroll', updateDots, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.ygTwsDot, 10);
        const scrollWidth = track.scrollWidth - track.clientWidth;
        const targetScroll = (index / (totalDots - 1)) * scrollWidth;
        track.scrollTo({ left: targetScroll, behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-vertical-tab"] && !Shopify.designMode) return;
  try {
    
  /**
   * 垂直选项卡 (Vertical Tab) 组件
   * 用于在大屏（桌面端）展示垂直布局的选项卡，并在选中时切换对应的图片和文本内容。
   * 该组件继承自 HTMLElement，利用 Web Component 的生命周期和事件机制进行交互管理。
   */
  class YGVerticalTab extends HTMLElement {
    constructor() {
      super();
      // 初始化当前激活的选项卡索引，默认为第 0 个
      this.activeIndex = 0;
      // 绑定事件处理函数的 this 上下文，防止在事件回调中丢失
      this.handleTabHover = this.handleTabHover.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);
    }

    /**
     * 获取组件内的 DOM 元素引用并缓存，避免重复查询以提高性能。
     * @returns {Object} 包含各个 DOM 元素引用的对象
     */
    get sectionElements() {
      if (this._sectionElements) {
        return this._sectionElements;
      }

      this._sectionElements = {
        // 选项卡列表容器
        tabList: this.querySelector('.yg-vertical-tab__tab-list'),
        // 所有选项卡按钮数组
        tabs: Array.from(this.querySelectorAll('.yg-vertical-tab__tab')),
        // 所有媒体（图片）面板数组
        mediaPanels: Array.from(this.querySelectorAll('[data-tab-media]')),
        // 所有文本内容面板数组
        contentPanels: Array.from(this.querySelectorAll('[data-tab-panel]')),
      };

      return this._sectionElements;
    }

    /**
     * Web Component 被插入到 DOM 时触发的生命周期方法。
     * 用于绑定事件监听器和执行初始化设置。
     */
    connectedCallback() {
      // 确保只初始化一次，避免因 Shopify 编辑器重新渲染或其他原因重复执行
      if (this.initialized) {
        return;
      }

      this.initialized = true;

      // 为每个选项卡按钮绑定悬浮事件
      this.sectionElements.tabs.forEach((tab) => {
        tab.addEventListener('mouseenter', this.handleTabHover);
      });

      // 为选项卡列表容器绑定键盘按下事件，用以支持无障碍键盘导航 (ARIA)
      this.sectionElements.tabList?.addEventListener('keydown', this.handleTabKeydown);

      // 设置默认激活的选项卡
      this.setActiveTab(this.activeIndex);
    }

    /**
     * Web Component 从 DOM 中移除时触发的生命周期方法。
     * 用于清理事件监听器，避免内存泄漏。
     */
    disconnectedCallback() {
      // 移除选项卡按钮的悬浮事件监听
      this.sectionElements.tabs.forEach((tab) => {
        tab.removeEventListener('mouseenter', this.handleTabHover);
      });

      // 移除选项卡列表的键盘事件监听
      this.sectionElements.tabList?.removeEventListener('keydown', this.handleTabKeydown);

      // 标记为未初始化
      this.initialized = false;
    }

    /**
     * 选项卡悬浮事件处理函数
     * @param {Event} event - 鼠标悬浮事件对象
     */
    handleTabHover(event) {
      // 从自定义属性 data-tab-index 获取被悬浮选项卡的索引，并转换为数字类型
      const index = Number(event.currentTarget.dataset.tabIndex);
      this.setActiveTab(index);
    }

    /**
     * 选项卡键盘导航事件处理函数
     * 支持使用 Up/Down 方向键、Home 和 End 键在垂直选项卡间切换，以增强无障碍体验 (WAI-ARIA)。
     * @param {Event} event - 键盘事件对象
     */
    handleTabKeydown(event) {
      // 如果按下的不是方向键上、方向键下、Home 或 End 键，则不进行处理
      if (!['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) {
        return;
      }

      const lastIndex = this.sectionElements.tabs.length - 1;
      let nextIndex = this.activeIndex;

      // 根据按下的键计算下一个应该被激活的选项卡索引（支持循环切换）
      if (event.key === 'ArrowUp') {
        nextIndex = this.activeIndex > 0 ? this.activeIndex - 1 : lastIndex;
      } else if (event.key === 'ArrowDown') {
        nextIndex = this.activeIndex < lastIndex ? this.activeIndex + 1 : 0;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = lastIndex;
      }

      // 阻止默认滚动行为，并聚焦及激活目标选项卡
      event.preventDefault();
      this.sectionElements.tabs[nextIndex]?.focus();
      this.setActiveTab(nextIndex);
    }

    /**
     * 切换当前激活的选项卡，并更新对应的媒体和文本面板，同时更新 WAI-ARIA 无障碍属性。
     * @param {number} index - 目标选项卡的索引
     */
    setActiveTab(index) {
      const tabCount = this.sectionElements.tabs.length;

      // 如果没有任何选项卡，直接返回
      if (tabCount === 0) {
        return;
      }

      // 确保目标索引在有效范围内 [0, tabCount - 1]
      const safeIndex = Math.max(0, Math.min(index, tabCount - 1));
      this.activeIndex = safeIndex;

      // 1. 更新选项卡按钮的状态和 ARIA 属性
      this.sectionElements.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === safeIndex;
        // 切换 .is-active 类名
        tab.classList.toggle('is-active', isActive);
        // 更新 aria-selected 状态，告知屏幕阅读器当前是否被选中
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        // 更新 tabindex 属性，仅允许激活项接收键盘焦点，非激活项可通过方向键切换
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      // 2. 更新对应的媒体（图片）面板的显示状态
      this.sectionElements.mediaPanels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === safeIndex;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      // 3. 更新对应的文本内容面板的显示状态
      this.sectionElements.contentPanels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === safeIndex;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }
  }

  // 如果尚未注册，则将自定义元素注册为 yg-vertical-tab，避免重复定义导致报错
  if (!window.customElements.get('yg-vertical-tab')) {
    window.customElements.define('yg-vertical-tab', YGVerticalTab);
  }

  } catch(e) { console.error(e); }
})();
})();
